export const idParams = (id: string) => ({ params: { id } });
